import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { RuntimeEnvironment } from '../types';
import { Url } from '@wix/da-url';
import { PapiSession } from '@wix/da-papi-types';
import s from './dre.scss';

export interface Props {
  environment?: RuntimeEnvironment;
  dre: PapiSession['dre'];
}

// Just triggering a full build...
const DRE: React.FC<Props> = ({ environment, dre }) => {
  const [appInfo, updateAppInfo] = useState('n/a');

  useEffect(() => {
    updateAppInfo(window['__APP_INFO__']);
  }, []);

  const url = Url.buildFromPath(
    `dre/share?dumpid=${dre?.dumpId}&token=${dre?.dumptoken}`,
    'https://admin.deviantart.com/'
  );

  const openWindow = () => {
    const win = window.open(
      url,
      'DRE_Console',
      `left=100,top=225,width=${Math.round(document.body.offsetWidth * 0.8)},height=${Math.round(
        screen.height * 0.7
      )},toolbar = 0, scrollbars = 1, location = 0, status = 0, statusmenubar = 0, resizable = 1`
    );
    if (!win) {
      return alert('DRE window has been blocked as a popup');
    }
    win.focus();
  };

  const wrapEvent = (eventCount, label) => {
    if (!eventCount) {
      return `0${label}`;
    }
    return (
      <span>
        <strong>{eventCount}</strong>
        {label}
      </span>
    );
  };

  return (
    <div
      className={classnames(s['root'], dre?.alarmEvents && dre?.alarmEvents > 0 && s['alert'])}
      onClick={openWindow}
    >
      {dre?.hostname} {dre?.totaltime}ms <br />
      <span className={s['alarms']}>{wrapEvent(dre?.alarmEvents, 'A')}</span>{' '}
      {wrapEvent(dre?.warningEvents, 'W')} {wrapEvent(dre?.noticeEvents, 'N')}{' '}
      {dre?.myEvents && wrapEvent(dre?.myEvents, 'M')}{' '}
      {dre?.quickEvents && wrapEvent(dre?.quickEvents, 'Q')} {wrapEvent(dre?.infoEvents, 'T')}
      <div className={s['info']} title={appInfo}>
        {appInfo}
      </div>
    </div>
  );
};

DRE.displayName = 'DRE';

export default DRE;
